// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"373":"bf4c31394727b14af50d","929":"9d204d8a1e36e08a2b3c"}[chunkId] + ".chunk.js";
};